import React from 'react';
import { Tooltip } from '@chakra-ui/react';

const ToggleIcons = () => {
  return (
    <Tooltip label={'Expand view'}>
      <svg
        width='19'
        height='19'
        viewBox='0 0 19 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <mask
          id='mask0_1542_829'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='19'
          height='19'
        >
          <rect x='0.755371' y='0.229126' width='18.1592' height='18.1592' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_1542_829)'>
          <path
            d='M3.78189 8.91154C3.78189 9.80689 4.08139 10.5761 4.68039 11.2193C5.27939 11.8624 6.02657 12.2218 6.92192 12.2975L5.74914 11.1247L6.80843 10.0654L9.83497 13.0919L6.80843 16.1185L5.74914 15.0592L6.95975 13.8486C5.63564 13.7729 4.52276 13.2622 3.6211 12.3164C2.71944 11.3706 2.26862 10.242 2.26862 8.93046C2.26862 7.5559 2.74467 6.39258 3.69676 5.44048C4.64886 4.48838 5.81219 4.01233 7.18674 4.01233H9.83497V5.5256H7.18674C6.24095 5.5256 5.43703 5.85347 4.77497 6.50922C4.11291 7.16498 3.78189 7.96575 3.78189 8.91154ZM11.3482 13.8486V12.3353H17.4013V13.8486H11.3482ZM11.3482 9.68709V8.17382H17.4013V9.68709H11.3482ZM11.3482 5.5256V4.01233H17.4013V5.5256H11.3482Z'
            fill='white'
          />
        </g>
      </svg>
    </Tooltip>
  );
};

export default ToggleIcons;
